import React from "react";
import Utils from "../../helpers/Utils";

class Item extends React.Component {
    onClick = e => {
        e.preventDefault();
        this.props.clickThumb(e, this.props.pos);
    }
  render() {
    this.props.parentHeight;
    return (
      <a
            key={this.props.item["artifact.uniqueId"]}
            onClick={this.onClick}
            href={this.props.url}
            className="gallery-list-item"
      >
        <figure>
            <div className="container-inner"
                style={{ height: this.props.imageHeight }}
            >
                <img
                    src={Utils.image.getUrl(this.props.item, 400)}
                    alt=''
                    pos={this.props.pos}
                    style={{
                      height:
                        this.props.imageHeight > this.props.imageWidth
                          ? "100%"
                          : "auto",
                      width:
                        this.props.imageHeight <= this.props.imageWidth
                          ? "100%"
                          : "auto"
                    }}
                />
          </div>
          <figcaption className="gallery-list-item-text">
              <div className="item-title">
                {this.props.item["artifact.ingress.title"]}{" "}
              </div>
              <div>{this.props.item["artifact.ingress.producer"]}</div>
              <div>
                {this.props.item["artifact.ingress.production.toYear"]
                  ? this.props.item["artifact.ingress.production.toYear"]
                  : this.props.noDateText}
              </div>
          </figcaption>
        </figure>
       
      </a>
    );
  }
}

export default Item;
